var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.schema && _vm.value && _vm.widgetSchema)?_c('div',[_c('t-simple-ls-form',{attrs:{"schema":_vm.widgetSchema,"value":_vm.value},on:{"input":v => _vm.$emit('input', v)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }